import { PropsWithChildren, useRef } from 'react';

import {
  createValidationConfigStore,
  ValidationConfigContext,
  ValidationConfigProps,
  ValidationConfigStore,
} from './validationConfigStore';

type ValidationConfigProviderProps = PropsWithChildren<ValidationConfigProps> & {
  validationId?: string;
};

export const ValidationConfigProvider = ({ validationId, children, ...props }: ValidationConfigProviderProps) => {
  const storeRef = useRef<ValidationConfigStore>(null);

  if (!storeRef.current) {
    storeRef.current = createValidationConfigStore(validationId, props);
  }

  if (storeRef.current?.getState().validationId !== validationId) {
    storeRef.current = createValidationConfigStore(validationId, props);
  }

  return <ValidationConfigContext.Provider value={storeRef.current}>{children}</ValidationConfigContext.Provider>;
};
